import React, { useRef, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Img1 from "../../../assets/General Engineering/Products/Mechanical Design/Koios Engineering Solutions Dyno v1.112.webp";
import Img2 from "../../../assets/General Engineering/Products/Mechanical Design/Koios Engineering Solutions Hopper 1 v8.110.webp";
import Img3 from "../../../assets/General Engineering/Products/Mechanical Design/Koios Engineering Solutions Machine Base V2 v41.44.webp";
import Img4 from "../../../assets/General Engineering/Products/Mechanical Design/Koios Engineering Solutions Bash plate v3.97.webp";
import Img5 from "../../../assets/General Engineering/Products/Mechanical Design/Koios Engineering Solutions 18x_4_v5_.webp";
import Img6 from "../../../assets/General Engineering/Products/Mechanical Design/Koios Engineering Solutions Product_Design_side_view.webp";
import Img7 from "../../../assets/General Engineering/Products/Mechanical Design/Koios Engineering Solutions Frame v7.49.webp";

function MechanicalDesign() {
  const sliderRef = useRef(null);
  const sliderContentRef = useRef(null);
  const indicatorRef = useRef(null);
  const [counter, setCounter] = useState(0);

  const slides = [Img1, Img2, Img3, Img4, Img5, Img6, Img7];
  const totalSlides = slides.length;

  useEffect(() => {
    updateSlider();
  }, [counter]);

  const updateSlider = () => {
    const sliderWidth = sliderContentRef.current.getBoundingClientRect().width;
    sliderContentRef.current.style.transform = `translateX(-${
      counter * sliderWidth
    }px)`;

    updateIndicator();
  };

  const updateIndicator = () => {
    const indicator = indicatorRef.current;
    if (!indicator) return;

    indicator.innerHTML = "";

    for (let i = 0; i < totalSlides; i++) {
      const div = document.createElement("div");
      div.className = "s-carousel-indicator-container";
      div.style.background = i === counter ? "#01cfdc" : "#c8c8c8";
      indicator.appendChild(div);
    }
  };

  const handleNext = () => {
    if (counter < totalSlides - 1) {
      setCounter((prev) => prev + 1);
    }
  };

  const handlePrev = () => {
    if (counter > 0) {
      setCounter((prev) => prev - 1);
    }
  };
  
  return (
    <div className="s-product-list-set">
      <div className="s-product-list-set-heading">
        <p className="heading">MECHANICAL</p>
        <p>Mechanical Design</p>
      </div>
      <div className="s-product-list-set-container">
        <div className="s-product-img-carousel" ref={sliderRef}>
          <div className="s-slider" ref={sliderContentRef}>
            {slides.map((img, index) => (
              <img
                loading="lazy"
                src={img}
                alt={`slide-${index}`}
                key={index}
              />
            ))}
          </div>

          <div
            className={`s-carousel-buttons s-previous-img ${
              counter === 0 ? "disabled" : ""
            }`}
            onClick={handlePrev}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="11"
              height="19"
              viewBox="0 0 11 19"
              fill="none"
            >
              <path
                d="M10.1706 1.97203L2.78871 9.35394L10.1706 16.7358L8.19858 18.7079L0.816672 11.326C0.293757 10.8029 0 10.0936 0 9.35394C0 8.61431 0.293757 7.90497 0.816672 7.3819L8.19858 -1.14441e-05L10.1706 1.97203Z"
                fill="#D7D6D6"
              />
            </svg>
          </div>

          <div
            className={`s-carousel-buttons s-next-img ${
              counter === totalSlides - 1 ? "disabled" : ""
            }`}
            onClick={handleNext}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="11"
              height="19"
              viewBox="0 0 11 19"
              fill="none"
            >
              <path
                d="M-0.00069809 16.7359L7.38121 9.35395L-0.00069809 1.97204L1.97134 0L9.35325 7.38191C9.87616 7.90498 10.1699 8.61432 10.1699 9.35395C10.1699 10.0936 9.87616 10.8029 9.35325 11.326L1.97134 18.7079L-0.00069809 16.7359Z"
                fill="#D7D6D6"
              />
            </svg>
          </div>

          <div className="s-carousel-indicator" ref={indicatorRef}></div>
        </div>
        <p className="subpage-desc">
          Utilizing CAD software and various analysis tools to engineer precise
          components and systems tailored to specific requirements. By
          integrating principles of mechanics, materials science, and
          manufacturing techniques, these tools ensure optimal functionality and
          reliability in mechanical designs.
        </p>
        <Link to="/mechanical_design">
          <span>Explore More</span>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="8"
            height="14"
            viewBox="0 0 8 14"
            fill="none"
          >
            <path
              d="M1.81139 13.707L0.400391 12.293L5.68938 6.99997L0.400391 1.70697L1.81539 0.292969L7.10038 5.58597C7.47532 5.96102 7.68595 6.46964 7.68595 6.99997C7.68595 7.5303 7.47532 8.03891 7.10038 8.41397L1.81139 13.707Z"
              fill="#FFBF00"
            />
          </svg>
        </Link>
      </div>
    </div>
  );
}

export default MechanicalDesign;
